let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cnPBg")).then(() => parcelRequire('hvMu4'));